"use client";

import { motion } from "framer-motion";

interface Step {
  number: string;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: "01",
    title: "Book turnover services online",
    description: "Book linen hire, towel hire, and turnover coordination through one portal, with clear time slots in every city we operate in."
  },
  {
    number: "02",
    title: "Delivered to your door, next day",
    description: "Choose a delivery window from 7am to 7pm for next day delivery and replenishment."
  },
  {
    number: "03",
    title: "Seven days a week coverage",
    description: "Schedule deliveries any day of the week to match your property turnover plan."
  },
  {
    number: "04",
    title: "Precise 90 minute delivery windows",
    description: "We aim to deliver within a defined 90 minute slot, so you can run cleaning operations to a predictable schedule."
  }
];

export function OperationsLifecycle() {
  return (
    <div className="w-full">
      {/* Header */}
      <div className="mb-10 lg:mb-12">
        <motion.span 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
          className="inline-block text-xs font-bold uppercase tracking-widest text-teal-600 mb-3"
        >
          Our Process
        </motion.span>
        <motion.h2 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.1 }}
          viewport={{ once: true }}
          className="text-xl sm:text-2xl lg:text-3xl font-satoshi font-bold text-gray-900 leading-tight"
        >
          How Replenico operates
        </motion.h2>
      </div>

      {/* Grid Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
        {steps.map((step, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.08 }}
            viewport={{ once: true }}
            className="relative group"
          >
            {/* Number Badge */}
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-teal-500/10 mb-4 group-hover:bg-teal-500/15 transition-colors">
              <span className="text-xl font-extrabold text-teal-600">
                {step.number}
              </span>
            </div>

            {/* Content */}
            <div>
              <h3 className="text-base sm:text-lg font-satoshi font-semibold text-gray-800 mb-2">
                {step.title}
              </h3>
              <p className="text-sm sm:text-base font-light text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
